import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useController } from './controller';

export const spinAnimation = keyframes`
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
`;
export const main = styled.div`
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    position: fixed;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    z-index: 999999999999;
    justify-content: center;
    align-items: center;
`;
export const modal = styled.div`
    font-family: 'Inter', sans-serif;
    max-width: 40%;
    max-height: 400px;
    background-color: var(--palette-one-white);
    box-shadow: 0px 0px 10px 0px rgba(255, 255, 255, 0.60);
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    position: relative;
    padding: 20px;

    @media(max-width: 1200px){
        max-width: 60%;
    }

    @media(max-width: 900px){
        max-width: 80%;
    }
`;
export const header = styled.div`
    width: calc(100% - 30px);
    height: calc(40px - 20px);
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    margin: 10px 15px;

    @media(max-width: 500px){
        width: calc(100% - 20px);
    }
`;

export const close = styled(FontAwesomeIcon)`
    font-size: 1.75rem;
    color: var(--palette-one-dark-blue);
    cursor: pointer;

    &:hover{
        color: red;
    }
`;

export const headerTitle = styled.h1`
    color: var(--palette-one-dark-blue);
    font-family: 'Inter', sans-serif;
    font-size: 1.75rem;
    text-transform: capitalize;

    @media(max-width: 900px){
        font-size: 1.5rem;
    }

    @media(max-width: 500px){
        font-size: 1.3rem;
    }
`;

export const explanation = styled.div`
    color: var(--palette-one-dark-blue);
    font-family: 'Inter', sans-serif;
    padding: 40px 20px;
    max-height: 80%;
    font-size: 1.5rem;
    overflow-y: auto;
    white-space: pre-line;
    align-content: center;

    @media(max-width: 1200px){
        font-size: 1.3rem;
    }

    @media(max-width: 900px){
        font-size: 1.2rem;
    }

    @media(max-width: 500px){
        font-size: 1rem;
    }
`;